import { observer } from 'mobx-react-lite'
import { type OpportunityViewModel } from '@/features/opportunities/OpportunityViewModel'
import { OpportunityListItem } from '@/features/opportunities/components/Opportunities/OpportunitiesList/OpportunityListItem'

export interface OpportunityListItemContainerProps {
  opportunityVm: OpportunityViewModel
  showWorkspaceInfo: boolean
}

export const OpportunityListItemContainer = observer(
  function OpportunityListItemContainer({
    opportunityVm,
    showWorkspaceInfo,
  }: OpportunityListItemContainerProps) {
    const opportunity = opportunityVm.opportunity
    return (
      <OpportunityListItem
        name={opportunity.name}
        description={opportunityVm.scopeItemsDescription}
        client={opportunityVm.visibleClient}
        workspaceName={opportunity.workspace.name}
        workspaceIcon={opportunity.workspace.branding.logos.icon}
        showWorkspaceInfo={showWorkspaceInfo}
        isDisabled={opportunityVm.disabled}
        selected={opportunityVm.isSelected}
        onSelect={opportunityVm.select}
        selectionCountdown={opportunityVm.selectionCountdown}
        deadline={opportunityVm.deadline}
        providerCutAmount={opportunityVm.providerCutAmount}
        testId={'opportunity-list-item-' + opportunity.name}
      />
    )
  },
)
